import request from '../request/request';

const API_URL = '/api/auth/v1';

export const privilegedLogin = (username, password) => {
  return request(
    {
      url: `${API_URL}/privileged-login`,
      method: 'POST',
      data: { username, password }
    },
    false
  );
};

export const privilegedMfaVerify = (totp, token, challengeSecret) => {
  return request(
    {
      url: `${API_URL}/privileged-login-totp`,
      method: 'POST',
      data: { totp, token, challengeSecret }
    },
    false
  );
};

export const privilegedMfaSetup = (token, challengeSecret) => {
  return request({
    url: `${API_URL}/privileged-login/mfa/setup`,
    method: 'POST',
    data: { token, challengeSecret, deviceName: 'default' }
  });
};

export const privilegedMfaConfirm = (token, challengeSecret, totpCode) => {
  return request({
    url: `${API_URL}/privileged-login/mfa/confirm`,
    method: 'POST',
    data: { token, challengeSecret, totpCode, deviceName: 'default' }
  });
};

export const privilegedLogout = () => {
  return request({
    url: `${API_URL}/privileged-logout`,
    method: 'POST'
  });
};
